module.exports = __webpack_public_path__ + "static/img/6.f046598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coupon_direction/ios/6.jpg
// module id = +IFj
// module chunks = 1